module.exports = __webpack_public_path__ + "static/media/MR.33c58ab4.png";